import {
	GET_REPORTS,
	FETCH_REPORT,
	UPDATE_REPORT,
	DELETE_REPORT,
	REGENERATE_REPORT_DIMENSION,
	GET_REPORTS_GENERATION_QUEUE,
} from "constants/actions";

const initialState = {
	reports: [],
	generation_queue: [],
	regenerate: null,
	pageNumber: 1,
	pending: false,
	updated: false,
	created: [],
	queryParams: [],
};

export default function ActionReport(state = initialState, action) {
	switch (action.type) {
		case GET_REPORTS:
			return {
				...state,
				reports: action.payload,
				pending: false,
				updated: false,
			};

		case FETCH_REPORT:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case UPDATE_REPORT:
			if (state.reports && Array.isArray(state.reports)) {
				const exists = state.reports.find((r) => r.id === action.payload.id);
				const reports = exists
					? state.reports.map((r) => (r.id === action.payload.id ? action.payload : r))
					: [...state.reports, action.payload];

				return {
					...state,
					reports,
					[action.payload.id]: action.payload,
					pending: false,
					updated: action.payload,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
				updated: action.payload,
			};

		case DELETE_REPORT:
			return {
				...state,
				reports: (state.reports || []).filter((row) => row.id !== action.payload),
				pending: false,
				updated: true,
			};
		case REGENERATE_REPORT_DIMENSION:
			return {
				...state,
				regenerate: action.payload,
				pending: false,
			};
		case GET_REPORTS_GENERATION_QUEUE:
			return {
				...state,
				generation_queue: action.payload,
				pending: false,
			};

		default:
			return state;
	}
}

